import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    value: PropTypes.number.isRequired,
    color: PropTypes.oneOf(['orange', 'green', 'red']),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    color: 'green',
};

class ProgressBar extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-progressbar',
            className,
        ];
    }

    renderChildren() {
        const { color } = this.props;
        const style = {
            width: `${this.props.value}%`,
        };
        const contentClassName = `c-progressbar__content_color_${color} c-progressbar__content`;
        return (
            <div
                className={contentClassName}
                style={style}
            />
        );
    }

}

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
